import { CHANGE_LANGUAGE } from '../actions/types';

const initialState = 'en';

export default (state = initialState, action) => {
    switch (action.type) {
        case CHANGE_LANGUAGE:
            return action.payload;
        default:
            return state;
    }
};
